export { default as VictoryTooltip } from "./victory-tooltip";
export { default as Flyout } from "./flyout";


//////////////////
// WEBPACK FOOTER
// ./~/victory-tooltip/es/index.js
// module id = ./node_modules/victory-tooltip/es/index.js
// module chunks = 1